import React, { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";

export const NormaTecnicaControllerContext = createContext();

export const ACTIONS = {
  SET_DATA_TABLE: "SET_DATA_TABLE",
};

const initialState = {
  dataTable: null,
};

const NormaTecnicaControllerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DATA_TABLE: {
      return {
        ...state,
        dataTable: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

const NormaTecnicaControllerContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer( NormaTecnicaControllerReducer, initialState );

  useEffect(() => {
    LiferayService.getAllDatos(properties.base_url_api).then(
      (response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_DATA_TABLE
        });
      }
    );
  }, []);

  return (
    <NormaTecnicaControllerContext.Provider value={[state, dispatch]}>
      {children}
    </NormaTecnicaControllerContext.Provider>
  );
};

export default NormaTecnicaControllerContextProvider;
